export enum CompanyCategoryEnum {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
  RECOGNISED = 'RECOGNISED',
  TRUST = 'TRUST',
}

export enum CompanyTypeDetailEnum {
  LIMITED_BY_SHARES = 'LIMITED_BY_SHARES',
  LIMITED_BY_GUARANTEE = 'LIMITED_BY_GUARANTEE',
  LIMITED_BY_SHARES_AND_GUARANTEE = 'LIMITED_BY_SHARES_AND_GUARANTEE',
  UNLIMITED = 'UNLIMITED',
}

export enum ApplicantPositionEnum {
  MANAGING_DIRECTOR = 'MANAGING_DIRECTOR',
  CHAIRPERSON = 'CHAIRPERSON',
  POWER_OF_ATTORNEY = 'POWER_OF_ATTORNEY',
}

export enum OfficeTypeEnum {
  PHYSICAL = 'PHYSICAL',
  VIRTUAL = 'VIRTUAL',
}

export enum ShareTypeEnum {
  ORDINARY = 'ORDINARY',
  PREFERENCE = 'PREFERENCE',
  REDEEMABLE = 'REDEEMABLE',
  NON_VOTING = 'NON_VOTING',
}

export enum ShareholderTypeEnum {
  INDIVIDUAL = 'INDIVIDUAL',
  LEGAL_ENTITY = 'LEGAL_ENTITY',
}

export enum DirectorPositionEnum {
  CHAIRMAN = 'CHAIRMAN',
  DIRECTOR = 'DIRECTOR',
  SECRETARY = 'SECRETARY',
  MEMBER = 'MEMBER',
}

export enum BusinessSectorEnum {
  AGRICULTURE = 'AGRICULTURE',
  FORESTRY = 'FORESTRY',
  FISHING_AND_AQUACULTURE = 'FISHING_AND_AQUACULTURE',
  MINING = 'MINING',
  QUARRYING = 'QUARRYING',
  MANUFACTURING = 'MANUFACTURING',
  CONSTRUCTION = 'CONSTRUCTION',
  WHOLESALE_TRADE = 'WHOLESALE_TRADE',
  RETAIL_TRADE = 'RETAIL_TRADE',
  BANKING_FINANCIAL_INSTITUTIONS = 'BANKING_FINANCIAL_INSTITUTIONS',
  CAPITAL_MARKETS_SECURITIES_SERVICES = 'CAPITAL_MARKETS_SECURITIES_SERVICES',
  EXCHANGES_TRADING_PLATFORMS = 'EXCHANGES_TRADING_PLATFORMS',
  INSURANCE_RISK_SERVICES = 'INSURANCE_RISK_SERVICES',
  FINTECH_DIGITAL_FINANCIAL_SERVICES = 'FINTECH_DIGITAL_FINANCIAL_SERVICES',
  GAMING_BETTING_OPERATIONS = 'GAMING_BETTING_OPERATIONS',
  ANCILLARY_SERVICES = 'ANCILLARY_SERVICES',
  ARBITRATION_DISPUTE_RESOLUTION = 'ARBITRATION_DISPUTE_RESOLUTION',

}

export enum MainBusinessActivityEnum {
  // Agriculture
  CROP_FARMING = 'CROP_FARMING',
  LIVESTOCK_FARMING = 'LIVESTOCK_FARMING',
  HORTICULTURE = 'HORTICULTURE',
  AGRICULTURAL_TRADING = 'AGRICULTURAL_TRADING',
  AGRO_PROCESSING = 'AGRO_PROCESSING',
  // Forestry
  FORESTRY_MANAGEMENT = 'FORESTRY_MANAGEMENT',
  TIMBER_PRODUCTION = 'TIMBER_PRODUCTION',
  FORESTRY_PRODUCT_TRADING = 'FORESTRY_PRODUCT_TRADING',
  // Fishing & Aquaculture
  FISHING_ACTIVITIES = 'FISHING_ACTIVITIES',
  FISH_FARMING = 'FISH_FARMING',
  FISH_PROCESSING = 'FISH_PROCESSING',
  FISH_TRADING = 'FISH_TRADING',
  // Mining
  MINERAL_EXTRACTION = 'MINERAL_EXTRACTION',
  MINERAL_PROCESSING = 'MINERAL_PROCESSING',
  MINING_SUPPORT_SERVICES = 'MINING_SUPPORT_SERVICES',
  // Quarrying
  STONE_QUARRYING = 'STONE_QUARRYING',
  SAND_MINING = 'SAND_MINING',
  CONSTRUCTION_MATERIAL_EXTRACTION = 'CONSTRUCTION_MATERIAL_EXTRACTION',
  // Manufacturing
  FOOD_BEVERAGE_MANUFACTURING = 'FOOD_BEVERAGE_MANUFACTURING',
  TEXTILE_GARMENT_MANUFACTURING = 'TEXTILE_GARMENT_MANUFACTURING',
  CHEMICAL_MANUFACTURING = 'CHEMICAL_MANUFACTURING',
  METAL_PLASTIC_MANUFACTURING = 'METAL_PLASTIC_MANUFACTURING',
  GENERAL_INDUSTRIAL_MANUFACTURING = 'GENERAL_INDUSTRIAL_MANUFACTURING',
  // Construction
  BUILDING_CONSTRUCTION = 'BUILDING_CONSTRUCTION',
  CIVIL_ENGINEERING_WORKS = 'CIVIL_ENGINEERING_WORKS',
  ROAD_CONSTRUCTION = 'ROAD_CONSTRUCTION',
  ELECTRICAL_PLUMBING_WORKS = 'ELECTRICAL_PLUMBING_WORKS',
  CONSTRUCTION_CONSULTANCY = 'CONSTRUCTION_CONSULTANCY',
  // Wholesale Trade
  WHOLESALE_DISTRIBUTION = 'WHOLESALE_DISTRIBUTION',
  BULK_COMMODITY_TRADING = 'BULK_COMMODITY_TRADING',
  IMPORT_WHOLESALING = 'IMPORT_WHOLESALING',
  // Retail Trade
  RETAIL_SHOPS = 'RETAIL_SHOPS',
  ONLINE_RETAIL = 'ONLINE_RETAIL',
  CONSUMER_GOODS_SALES = 'CONSUMER_GOODS_SALES',

  INVESTMENT_BANKING = 'INVESTMENT_BANKING',
  MERCHANT_BANKING = 'MERCHANT_BANKING',
  COMMERCIAL_BANKING = 'COMMERCIAL_BANKING',
  FULL_BANKING_SERVICES = 'FULL_BANKING_SERVICES',
  MORTGAGE_FINANCING = 'MORTGAGE_FINANCING',
  DIGITAL_BANKING = 'DIGITAL_BANKING',
  REPRESENTATIVE_OFFICE_OPERATIONS = 'REPRESENTATIVE_OFFICE_OPERATIONS',

  SECURITIES_DEALING_BROKERAGE = 'SECURITIES_DEALING_BROKERAGE',
  INVESTMENT_ADVISORY_SERVICES = 'INVESTMENT_ADVISORY_SERVICES',
  CONTRACTS_FOR_DIFFERENCES_TRADING = 'CONTRACTS_FOR_DIFFERENCES_TRADING',
  CREDIT_RATING_SERVICES = 'CREDIT_RATING_SERVICES',
  CENTRAL_SECURITIES_DEPOSITORY_SERVICES = 'CENTRAL_SECURITIES_DEPOSITORY_SERVICES',
  CLEARING_AND_SETTLEMENT_SERVICES = 'CLEARING_AND_SETTLEMENT_SERVICES',
  CROWDFUNDING_OPERATIONS = 'CROWDFUNDING_OPERATIONS',
  TRUSTEE_CUSTODIAN_SERVICES = 'TRUSTEE_CUSTODIAN_SERVICES',

  STOCK_EXCHANGE_OPERATIONS = 'STOCK_EXCHANGE_OPERATIONS',
  CRYPTO_DIGITAL_ASSET_EXCHANGE_OPERATIONS = 'CRYPTO_DIGITAL_ASSET_EXCHANGE_OPERATIONS',

  GENERAL_INSURANCE = 'GENERAL_INSURANCE',
  LONG_TERM_INSURANCE = 'LONG_TERM_INSURANCE',
  REINSURANCE_SERVICES = 'REINSURANCE_SERVICES',
  INSURANCE_BROKERAGE = 'INSURANCE_BROKERAGE',
  INSURANCE_AGENCY_SERVICES = 'INSURANCE_AGENCY_SERVICES',

  SANDBOX_FINTECH_SOLUTIONS = 'SANDBOX_FINTECH_SOLUTIONS',
  DIGITAL_FINANCIAL_SERVICES = 'DIGITAL_FINANCIAL_SERVICES',
  NON_CUSTODIAL_FINTECH_PLATFORMS = 'NON_CUSTODIAL_FINTECH_PLATFORMS',
  CUSTODIAL_FINTECH_PLATFORMS = 'CUSTODIAL_FINTECH_PLATFORMS',
  TOKEN_ISSUANCE_PLATFORMS = 'TOKEN_ISSUANCE_PLATFORMS',

  LOTTO_OPERATIONS = 'LOTTO_OPERATIONS',
  E_CASINO_OPERATIONS = 'E_CASINO_OPERATIONS',
  SPORTS_BETTING_SERVICES = 'SPORTS_BETTING_SERVICES',

  LEGAL_SERVICES = 'LEGAL_SERVICES',
  ACCOUNTING_SERVICES = 'ACCOUNTING_SERVICES',
  AUDITING_SERVICES = 'AUDITING_SERVICES',
  BUSINESS_CONSULTING = 'BUSINESS_CONSULTING',

  ARBITRATION_CASE_HANDLING = 'ARBITRATION_CASE_HANDLING',
  ARBITRATOR_SERVICES = 'ARBITRATOR_SERVICES',
  DISPUTE_RESOLUTION_SERVICES = 'DISPUTE_RESOLUTION_SERVICES',

  AUCTION_SERVICES = 'AUCTION_SERVICES',
  
}

export enum NationalityEnum {
  CITIZEN = 'CITIZEN',
  ALIEN = 'ALIEN',
}

export enum TrustTypeEnum {
  FAMILY = 'FAMILY',
  NON_FAMILY = 'NON_FAMILY',
}

export enum TrustCategoryEnum {
  FOUNDER = 'FOUNDER',
  FOUNDER_REPRESENTATIVE = 'FOUNDER_REPRESENTATIVE',
}

export enum CurrencyEnum {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
  ZAR = 'ZAR',
  ZWL = 'ZWL',
}

export enum SourceOfFundsEnum {
  SALARY = 'SALARY',
  INHERITANCE = 'INHERITANCE'
}

export enum CountryEnum {
  ZIMBABWE = 'ZIMBABWE',
  SOUTH_AFRICA = 'SOUTH_AFRICA',
  ZAMBIA = 'ZAMBIA',
  BOTSWANA = 'BOTSWANA',
  MOZAMBIQUE = 'MOZAMBIQUE',
  MALAWI = 'MALAWI',
  TANZANIA = 'TANZANIA',
  KENYA = 'KENYA',
  UGANDA = 'UGANDA',
  RWANDA = 'RWANDA',
  UNITED_KINGDOM = 'UNITED_KINGDOM',
  UNITED_STATES = 'UNITED_STATES',
  CHINA = 'CHINA',
  INDIA = 'INDIA',
  OTHER = 'OTHER',
}

export enum CompanyTypeEnum {
  LIMITED_LIABILITY = 'LIMITED_LIABILITY',
  PUBLIC_COMPANY = 'PUBLIC_COMPANY',
  BRANCH = 'BRANCH',
  FUND = 'FUND',
  SPV = 'SPV',
  FOREIGN_COMPANY = 'FOREIGN_COMPANY',
}

export enum CompanyStatusEnum {
  PENDING = 'PENDING',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  NEEDS_INFO = 'NEEDS_INFO',
}

export enum CompanyStageEnum {
  SEED = 'SEED',
  ANGEL = 'ANGEL',
  VC = 'VC',
  GROWTH = 'GROWTH',
  MATURE = 'MATURE',
}

export enum ApplicationTypeEnum {
  COMPANY = 'COMPANY',
  ENTERPRISE = 'ENTERPRISE',
  PARTNERSHIP = 'PARTNERSHIP',
}

export enum NameReservationStatusEnum {
  SUBMITTED = 'SUBMITTED',
  APPROVED = 'APPROVED',
  REJECTED = 'REJECTED',
  EXPIRED = 'EXPIRED',
}

export const COMPANY_CATEGORY_OPTIONS = [
  { value: CompanyCategoryEnum.PRIVATE, label: 'Private Company' },
  { value: CompanyCategoryEnum.PUBLIC, label: 'Public Company' },
  { value: CompanyCategoryEnum.RECOGNISED, label: 'Recognized (Foreign) Company' },
];

export const COMPANY_TYPE_OPTIONS = [
  { value: CompanyTypeDetailEnum.LIMITED_BY_SHARES, label: 'Limited by Shares' },
  { value: CompanyTypeDetailEnum.LIMITED_BY_GUARANTEE, label: 'Limited by Guarantee' },
  {
    value: CompanyTypeDetailEnum.LIMITED_BY_SHARES_AND_GUARANTEE,
    label: 'Limited by Shares and Guarantee',
  },
  { value: CompanyTypeDetailEnum.UNLIMITED, label: 'Unlimited' },
];

export const COMPANY_TYPE_DETAIL_OPTIONS = COMPANY_TYPE_OPTIONS; // Alias for clarity

export const APPLICANT_POSITION_OPTIONS = [
  { value: ApplicantPositionEnum.MANAGING_DIRECTOR, label: 'Managing Director' },
  { value: ApplicantPositionEnum.CHAIRPERSON, label: 'Chairperson' },
  { value: ApplicantPositionEnum.POWER_OF_ATTORNEY, label: 'Power of Attorney' },
];

export const OFFICE_TYPE_OPTIONS = [
  { value: OfficeTypeEnum.PHYSICAL, label: 'Physical Office' },
  { value: OfficeTypeEnum.VIRTUAL, label: 'Virtual Office' },
];

export const SHARE_TYPE_OPTIONS = [
  { value: ShareTypeEnum.ORDINARY, label: 'Ordinary Shares' },
  { value: ShareTypeEnum.PREFERENCE, label: 'Preference Shares' },
  { value: ShareTypeEnum.REDEEMABLE, label: 'Redeemable Shares' },
  { value: ShareTypeEnum.NON_VOTING, label: 'Non-Voting Shares' },
];

export const SHAREHOLDER_TYPE_OPTIONS = [
  { value: ShareholderTypeEnum.INDIVIDUAL, label: 'Individual' },
  { value: ShareholderTypeEnum.LEGAL_ENTITY, label: 'Legal Entity' },
];

export const DIRECTOR_POSITION_OPTIONS = [
  { value: DirectorPositionEnum.CHAIRMAN, label: 'Chairman' },
  { value: DirectorPositionEnum.DIRECTOR, label: 'Director' },
  { value: DirectorPositionEnum.SECRETARY, label: 'Secretary' },
  { value: DirectorPositionEnum.MEMBER, label: 'Member' },
];

export const BUSINESS_SECTOR_OPTIONS = [
  { value: BusinessSectorEnum.AGRICULTURE, label: 'Agriculture' },
  { value: BusinessSectorEnum.FORESTRY, label: 'Forestry' },
  { value: BusinessSectorEnum.FISHING_AND_AQUACULTURE, label: 'Fishing & Aquaculture' },
  { value: BusinessSectorEnum.MINING, label: 'Mining' },
  { value: BusinessSectorEnum.QUARRYING, label: 'Quarrying' },
  { value: BusinessSectorEnum.MANUFACTURING, label: 'Manufacturing' },
  { value: BusinessSectorEnum.CONSTRUCTION, label: 'Construction' },
  { value: BusinessSectorEnum.WHOLESALE_TRADE, label: 'Wholesale Trade' },
  { value: BusinessSectorEnum.RETAIL_TRADE, label: 'Retail Trade' },
  { value: BusinessSectorEnum.BANKING_FINANCIAL_INSTITUTIONS, label: 'Banking & Financial Institutions' },
  { value: BusinessSectorEnum.CAPITAL_MARKETS_SECURITIES_SERVICES, label: 'Capital Markets & Securities Services' },
  { value: BusinessSectorEnum.EXCHANGES_TRADING_PLATFORMS, label: 'Exchanges & Trading Platforms' },
  { value: BusinessSectorEnum.INSURANCE_RISK_SERVICES, label: 'Insurance & Risk Services' },
  { value: BusinessSectorEnum.FINTECH_DIGITAL_FINANCIAL_SERVICES, label: 'FinTech & Digital Financial Services' },
  { value: BusinessSectorEnum.GAMING_BETTING_OPERATIONS, label: 'Gaming & Betting Operations' },
  { value: BusinessSectorEnum.ANCILLARY_SERVICES, label: 'Ancillary Services' },
  { value: BusinessSectorEnum.ARBITRATION_DISPUTE_RESOLUTION, label: 'Arbitration & Dispute Resolution' },
];

export const getMainBusinessActivities = (sector: BusinessSectorEnum | null) => {
  if (!sector) return [];
  
  const activityMap: Record<BusinessSectorEnum, { value: MainBusinessActivityEnum; label: string }[]> = {
    [BusinessSectorEnum.AGRICULTURE]: [
      { value: MainBusinessActivityEnum.CROP_FARMING, label: 'Crop Farming' },
      { value: MainBusinessActivityEnum.LIVESTOCK_FARMING, label: 'Livestock Farming' },
      { value: MainBusinessActivityEnum.HORTICULTURE, label: 'Horticulture' },
      { value: MainBusinessActivityEnum.AGRICULTURAL_TRADING, label: 'Agricultural Trading' },
      { value: MainBusinessActivityEnum.AGRO_PROCESSING, label: 'Agro-processing' },
    ],
    [BusinessSectorEnum.FORESTRY]: [
      { value: MainBusinessActivityEnum.FORESTRY_MANAGEMENT, label: 'Forestry Management' },
      { value: MainBusinessActivityEnum.TIMBER_PRODUCTION, label: 'Timber Production' },
      { value: MainBusinessActivityEnum.FORESTRY_PRODUCT_TRADING, label: 'Forestry Product Trading' },
    ],
    [BusinessSectorEnum.FISHING_AND_AQUACULTURE]: [
      { value: MainBusinessActivityEnum.FISHING_ACTIVITIES, label: 'Fishing Activities' },
      { value: MainBusinessActivityEnum.FISH_FARMING, label: 'Fish Farming' },
      { value: MainBusinessActivityEnum.FISH_PROCESSING, label: 'Fish Processing' },
      { value: MainBusinessActivityEnum.FISH_TRADING, label: 'Fish Trading' },
    ],
    [BusinessSectorEnum.MINING]: [
      { value: MainBusinessActivityEnum.MINERAL_EXTRACTION, label: 'Mineral Extraction' },
      { value: MainBusinessActivityEnum.MINERAL_PROCESSING, label: 'Mineral Processing' },
      { value: MainBusinessActivityEnum.MINING_SUPPORT_SERVICES, label: 'Mining Support Services' },
    ],
    [BusinessSectorEnum.QUARRYING]: [
      { value: MainBusinessActivityEnum.STONE_QUARRYING, label: 'Stone Quarrying' },
      { value: MainBusinessActivityEnum.SAND_MINING, label: 'Sand Mining' },
      { value: MainBusinessActivityEnum.CONSTRUCTION_MATERIAL_EXTRACTION, label: 'Construction Material Extraction' },
    ],
    [BusinessSectorEnum.MANUFACTURING]: [
      { value: MainBusinessActivityEnum.FOOD_BEVERAGE_MANUFACTURING, label: 'Food and Beverage Manufacturing' },
      { value: MainBusinessActivityEnum.TEXTILE_GARMENT_MANUFACTURING, label: 'Textile and Garment Manufacturing' },
      { value: MainBusinessActivityEnum.CHEMICAL_MANUFACTURING, label: 'Chemical Manufacturing' },
      { value: MainBusinessActivityEnum.METAL_PLASTIC_MANUFACTURING, label: 'Metal and Plastic Manufacturing' },
      { value: MainBusinessActivityEnum.GENERAL_INDUSTRIAL_MANUFACTURING, label: 'General Industrial Manufacturing' },
    ],
    [BusinessSectorEnum.CONSTRUCTION]: [
      { value: MainBusinessActivityEnum.BUILDING_CONSTRUCTION, label: 'Building Construction' },
      { value: MainBusinessActivityEnum.CIVIL_ENGINEERING_WORKS, label: 'Civil Engineering Works' },
      { value: MainBusinessActivityEnum.ROAD_CONSTRUCTION, label: 'Road Construction' },
      { value: MainBusinessActivityEnum.ELECTRICAL_PLUMBING_WORKS, label: 'Electrical and Plumbing Works' },
      { value: MainBusinessActivityEnum.CONSTRUCTION_CONSULTANCY, label: 'Construction Consultancy' },
    ],
    [BusinessSectorEnum.WHOLESALE_TRADE]: [
      { value: MainBusinessActivityEnum.WHOLESALE_DISTRIBUTION, label: 'Wholesale Distribution' },
      { value: MainBusinessActivityEnum.BULK_COMMODITY_TRADING, label: 'Bulk Commodity Trading' },
      { value: MainBusinessActivityEnum.IMPORT_WHOLESALING, label: 'Import Wholesaling' },
    ],
    [BusinessSectorEnum.RETAIL_TRADE]: [
      { value: MainBusinessActivityEnum.RETAIL_SHOPS, label: 'Retail Shops' },
      { value: MainBusinessActivityEnum.ONLINE_RETAIL, label: 'Online Retail' },
      { value: MainBusinessActivityEnum.CONSUMER_GOODS_SALES, label: 'Consumer Goods Sales' },
    ],
    [BusinessSectorEnum.BANKING_FINANCIAL_INSTITUTIONS]: [
      { value: MainBusinessActivityEnum.INVESTMENT_BANKING, label: 'Investment Banking' },
      { value: MainBusinessActivityEnum.MERCHANT_BANKING, label: 'Merchant Banking' },
      { value: MainBusinessActivityEnum.COMMERCIAL_BANKING, label: 'Commercial Banking' },
      { value: MainBusinessActivityEnum.FULL_BANKING_SERVICES, label: 'Full Banking Services' },
      { value: MainBusinessActivityEnum.MORTGAGE_FINANCING, label: 'Mortgage Financing' },
      { value: MainBusinessActivityEnum.DIGITAL_BANKING, label: 'Digital Banking (Neo Banks)' },
      { value: MainBusinessActivityEnum.REPRESENTATIVE_OFFICE_OPERATIONS, label: 'Representative Office Operations' },
    ],

    [BusinessSectorEnum.CAPITAL_MARKETS_SECURITIES_SERVICES]: [
      { value: MainBusinessActivityEnum.SECURITIES_DEALING_BROKERAGE, label: 'Securities Dealing / Brokerage (Dealer/Broker)' },
      { value: MainBusinessActivityEnum.INVESTMENT_ADVISORY_SERVICES, label: 'Investment Advisory Services' },
      { value: MainBusinessActivityEnum.CONTRACTS_FOR_DIFFERENCES_TRADING, label: 'Contracts for Differences (CFD Trading)' },
      { value: MainBusinessActivityEnum.CREDIT_RATING_SERVICES, label: 'Credit Rating Services' },
      { value: MainBusinessActivityEnum.CENTRAL_SECURITIES_DEPOSITORY_SERVICES, label: 'Central Securities Depository Services' },
      { value: MainBusinessActivityEnum.CLEARING_AND_SETTLEMENT_SERVICES, label: 'Clearing and Settlement Services' },
      { value: MainBusinessActivityEnum.CROWDFUNDING_OPERATIONS, label: 'Crowdfunding Operations' },
      { value: MainBusinessActivityEnum.TRUSTEE_CUSTODIAN_SERVICES, label: 'Trustee / Custodian Services' },
    ],

    [BusinessSectorEnum.EXCHANGES_TRADING_PLATFORMS]: [
      { value: MainBusinessActivityEnum.STOCK_EXCHANGE_OPERATIONS, label: 'Stock Exchange Operations' },
      { value: MainBusinessActivityEnum.CRYPTO_DIGITAL_ASSET_EXCHANGE_OPERATIONS, label: 'Crypto / Digital Asset Exchange Operations' },
    ],

    [BusinessSectorEnum.INSURANCE_RISK_SERVICES]: [
      { value: MainBusinessActivityEnum.GENERAL_INSURANCE, label: 'General Insurance' },
      { value: MainBusinessActivityEnum.LONG_TERM_INSURANCE, label: 'Long-Term Insurance' },
      { value: MainBusinessActivityEnum.REINSURANCE_SERVICES, label: 'Reinsurance Services' },
      { value: MainBusinessActivityEnum.INSURANCE_BROKERAGE, label: 'Insurance Brokerage' },
      { value: MainBusinessActivityEnum.INSURANCE_AGENCY_SERVICES, label: 'Insurance Agency Services' },
    ],

    [BusinessSectorEnum.FINTECH_DIGITAL_FINANCIAL_SERVICES]: [
      { value: MainBusinessActivityEnum.SANDBOX_FINTECH_SOLUTIONS, label: 'Sandbox FinTech Solutions' },
      { value: MainBusinessActivityEnum.DIGITAL_FINANCIAL_SERVICES, label: 'Digital Financial Services' },
      { value: MainBusinessActivityEnum.NON_CUSTODIAL_FINTECH_PLATFORMS, label: 'Non-Custodial FinTech Platforms' },
      { value: MainBusinessActivityEnum.CUSTODIAL_FINTECH_PLATFORMS, label: 'Custodial FinTech Platforms' },
      { value: MainBusinessActivityEnum.TOKEN_ISSUANCE_PLATFORMS, label: 'Token Issuance Platforms' },
    ],

    [BusinessSectorEnum.GAMING_BETTING_OPERATIONS]: [
      { value: MainBusinessActivityEnum.LOTTO_OPERATIONS, label: 'Lotto Operations' },
      { value: MainBusinessActivityEnum.E_CASINO_OPERATIONS, label: 'E-Casino Operations' },
      { value: MainBusinessActivityEnum.SPORTS_BETTING_SERVICES, label: 'Sports Betting Services' },
    ],

    [BusinessSectorEnum.ANCILLARY_SERVICES]: [
      { value: MainBusinessActivityEnum.LEGAL_SERVICES, label: 'Legal Services' },
      { value: MainBusinessActivityEnum.ACCOUNTING_SERVICES, label: 'Accounting Services' },
      { value: MainBusinessActivityEnum.AUDITING_SERVICES, label: 'Auditing Services' },
      { value: MainBusinessActivityEnum.AUCTION_SERVICES, label: 'Auction Services' },
      { value: MainBusinessActivityEnum.BUSINESS_CONSULTING, label: 'Business Consulting' },
    ],

    [BusinessSectorEnum.ARBITRATION_DISPUTE_RESOLUTION]: [
      { value: MainBusinessActivityEnum.ARBITRATION_CASE_HANDLING, label: 'Arbitration Case Handling' },
      { value: MainBusinessActivityEnum.ARBITRATOR_SERVICES, label: 'Arbitrator Services' },
      { value: MainBusinessActivityEnum.DISPUTE_RESOLUTION_SERVICES, label: 'Dispute Resolution Services' },
    ],
    
  };

  return activityMap[sector] || [];
};

export const NATIONALITY_OPTIONS = [
  { value: NationalityEnum.CITIZEN, label: 'ZIMBABWEAN' },
];

export const TRUST_TYPE_OPTIONS = [
  { value: TrustTypeEnum.FAMILY, label: 'Family Trust' },
  { value: TrustTypeEnum.NON_FAMILY, label: 'Non-Family Trust' },
];

export const TRUST_CATEGORY_OPTIONS = [
  { value: TrustCategoryEnum.FOUNDER, label: 'Founder' },
  { value: TrustCategoryEnum.FOUNDER_REPRESENTATIVE, label: 'Founder Representative' },
];

export const CURRENCY_OPTIONS = [
  { value: CurrencyEnum.USD, label: 'USD - US Dollar' },
  { value: CurrencyEnum.ZWL, label: 'ZWL - Zimbabwean Dollar' },
];

export const SOURCE_OF_FUNDS_OPTIONS = [
  { value: SourceOfFundsEnum.SALARY, label: 'Salary' },
  { value: SourceOfFundsEnum.INHERITANCE, label: 'Inheritance' },
];

export const COUNTRY_OPTIONS: any[] = [];


export enum zoneEnum {
  HARARE = 'HARARE',
}

export enum districtEnum {
  HARARE_CENTRAL = 'HARARE_CENTRAL',
}

export const ZONE_OPTIONS = [
  { value: zoneEnum.HARARE, label: 'Harare' },
];

export const DISTRICT_OPTIONS = [
  { value: districtEnum.HARARE_CENTRAL, label: 'Harare Central' },
];
